import React, { useCallback, useMemo, useState } from "react";
import { Dialog } from "@activecollab/components";
import { ConversationInviteForm } from "../Hub/ConversationInviteForm.jsx";

export const useInviteOption = (onInviteSuccess) => {
  const [showInviteDialog, setShowInviteDialog] = useState(false);

  const handleOpenInviteDialog = useCallback(() => {
    setShowInviteDialog(true);
  }, []);

  const handleCloseInviteDialog = useCallback(() => {
    setShowInviteDialog(false);
  }, []);

  const handleSubmitInviteDialog = useCallback(() => {
    setShowInviteDialog(false);
    typeof onInviteSuccess === "function" && onInviteSuccess();
  }, [onInviteSuccess]);

  const inviteTemplate = useMemo(() => {
    return (
      <Dialog
        className="invite-form-dialog"
        open={showInviteDialog}
        onClose={handleCloseInviteDialog}
      >
        <ConversationInviteForm
          onCancel={handleCloseInviteDialog}
          onSubmit={handleSubmitInviteDialog}
        />
      </Dialog>
    );
  }, [handleCloseInviteDialog, handleSubmitInviteDialog, showInviteDialog]);

  return {
    onShowInviteDialog: handleOpenInviteDialog,
    inviteTemplate,
  };
};
